import { useState } from "react";
import { App } from "antd";
import VLAvatar from "views/uikit/VLAvatar";
import TrashIcon from "assets/icons/TrashIcon";
import styles from "./style.module.scss";
import classNames from "classnames";
import { CgSpinner } from "react-icons/cg";

export const UserRow = ({
  email,
  name,
  avatarIcon = (
    <div>
      <VLAvatar />
    </div>
  ),
  subtitle,
  classname,
  onRemoveUser,
  dataTestId,
}: {
  email: string;
  name?: string;
  avatarIcon?: React.ReactNode;
  subtitle?: string;
  classname?: string;
  onRemoveUser?: () => Promise<void>;
  dataTestId?: string;
}) => {
  const { modal } = App.useApp();
  const [removeInProgress, setRemoveInProgress] = useState<boolean>(false);
  const showRemoveButton = !!onRemoveUser;

  const renderRowEnd = () => {
    if (subtitle) {
      return subtitle;
    }
    if (removeInProgress) {
      return (
        <div className={styles.spinner} data-testid="spinner">
          <CgSpinner size={"20px"} />
        </div>
      );
    } else {
      return (
        <div data-testid="trash-icon">
          <TrashIcon />
        </div>
      );
    }
  };

  const handleRemoveClick = () => {
    modal.confirm({
      title: "Remove Member",
      content: "Are you sure you want to remove this user?",
      okText: "Remove Member",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: async () => {
        if (!onRemoveUser) {
          return;
        }
        setRemoveInProgress(true);
        await onRemoveUser();
        setRemoveInProgress(false);
      },
    });
  };

  return (
    <>
      <div
        className={classNames(styles.userWithAccessRow, classname)}
        key={email}
        data-testid={dataTestId}
      >
        {avatarIcon}
        <div>
          {name && <div>{name}</div>}
          <div>{email}</div>
        </div>
        <div
          className={classNames(styles.userRowEnd, {
            [styles.trashIcon]: showRemoveButton,
          })}
          onClick={showRemoveButton ? handleRemoveClick : () => {}}
        >
          {renderRowEnd()}
        </div>
      </div>
    </>
  );
};
